import posthog from "posthog-js";
import { useSignupFlowStore } from "./hooks/useSignUpFlowStore";

type FeatureFlagVariant = string | boolean;
type FeatureFlags = Record<string, FeatureFlagVariant>;

export const resolveFeatureFlagVariant = (
  flag: string,
  storedFeatureFlags: FeatureFlags | undefined,
  getFallbackVariant: () => FeatureFlagVariant | undefined,
): FeatureFlagVariant | undefined =>
  storedFeatureFlags?.[flag] ?? getFallbackVariant();

export const mergeFeatureFlagsWithStoredOverrides = (
  resolvedFeatureFlags: FeatureFlags,
  storedFeatureFlags: FeatureFlags,
): FeatureFlags => ({
  ...resolvedFeatureFlags,
  ...storedFeatureFlags,
});

/**
 * Non-React predicate that reads the resolved flag variant from the posthog-js
 * singleton. Used by validation helpers (reconcileValidatedFields,
 * findFirstIncompleteSignupPage, validatePrefilledFields) to resolve flags
 * from non-React callers.
 */
export const inABTestGroupFromSingleton = (flag: string): boolean =>
  resolveFeatureFlagVariant(
    flag,
    useSignupFlowStore.getState().featureFlags,
    () => posthog?.getFeatureFlag?.(flag),
  ) === "test";
